import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getDiscountList as getDiscountListApi,
    addDiscountList as addDiscountListApi,
    updateDiscountList as updateDiscountListApi,
    deleteDiscountList as deleteDiscountListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getDiscountList = createAsyncThunk("Discount/getDiscountList", async () => {
    try {
        const response = await getDiscountListApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const addDiscountList = createAsyncThunk("Discount/addDiscountList", async (category: any) => {
    try {
        const response = addDiscountListApi(category);
        const data = await response;
        toast.success("Discount Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Discount Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateDiscountList = createAsyncThunk("Discount/update", async (dataArr: any) => {
    try {
        const response = updateDiscountListApi(dataArr);
        const data = await response;
        toast.success("Discount Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Discount Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteDiscountList = createAsyncThunk("Discount/deleteDiscountList", async (categoryId: any) => {
    try {
        const response = deleteDiscountListApi(categoryId);
        console.log(response);
        toast.success("Discount Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Discount Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
